import React from 'react'
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import FuelStationsOwn from '../../views/fuel-stations/own-fuel-stations/OwnFuelStations'
import FuelStationsFavorites from '../../views/fuel-stations/fuel-stations-favorites/FuelStationsFavorites'
import NotificationsFuelStations from '../../views/fuel-stations/notifications-fuel-stations/NotificationsFuelStations'
import FuelStationsSpain from '../../views/fuel-stations/fuel-stations-spain/FuelStationsSpain'
import FuelStationsPrices from '../../views/fuel-stations/prices/FuelStationsPrices'
import Tanks from '../../views/fuel-stations/tanks/Tanks'

import Summary from '../../views/fuel-stations/summary/Summary'
import Margin from '../../views/fuel-stations/margin/Margin'

const fuelsStationsRoutes = [
  {
    path: pathname.summary.SUMMARY,
    name: 'summary',
    element: <Summary />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.PRICES,
      method: METHOD.GET,
    },
  },

  {
    path: pathname.margin.MARGIN,
    name: 'margin',
    element: <Margin />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.PRICES,
      method: METHOD.GET,
    },
  },

  {
    path: pathname.pricesFuelStations.PRICE_CHANGES,
    name: 'fuelStationsPrices',
    element: <FuelStationsPrices />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.PRICES,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.tanksFuelStations.TANKS,
    name: 'fuelStationsTanks',
    element: <Tanks />,
    role: {
      module: MODULES.ALVIC,
      group: GROUPS.TANKS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownsFuelStations.OWNS,
    name: 'fuelStationsOwn',
    element: <FuelStationsOwn />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.OWN,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.favoritesFuelStations.FAVORITES,
    name: 'fuelStationsFavorites',
    element: <FuelStationsFavorites />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.FAVORITE,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.spainFuelStations.SPAIN,
    name: 'fuelStationsSpain',
    element: <FuelStationsSpain />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.FUELSTATIONS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.notificationsFuelStations.NOTIFICATIONS,
    name: 'fuelStationsSettings',
    element: <NotificationsFuelStations />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.NOTIFICATION,
      method: METHOD.GET,
    },
  },
]

export default fuelsStationsRoutes
